import './index.less';
import { useRouter } from 'next/navigation';
import { sendEventAnalyses } from '@/lib/service';
import { ANONYMOUS_USER_ID } from '@/shared/constants';
import { EventName, EventSource } from '@/shared/constants/event';
import storage from '@/shared/utils/storage';
import { setAnonymousUser } from '@/shared/utils/utils';
import { useConfigProvider } from '@/lib/context';
import { PietraAgenticCard } from '@/shared/types/homepage';
import Image from 'next/image';
import { StarsPaywallFilled } from '@pietra/icons';

interface IProps {
  card: PietraAgenticCard;
}

const HomepageV4IntroCard = ({ card }: IProps) => {
  const router = useRouter();
  const { isMobile } = useConfigProvider();

  const handleJoinPietra = () => {
    sendEventAnalyses({
      eventName: EventName.COMMON_VIEW,
      commonType: EventSource.HOMEPAGE_CARD,
      commonContent: card.agentName,
      sourceClient: isMobile ? 'mobile_web' : 'desktop_web',
      anonymousUserId: storage.get(ANONYMOUS_USER_ID) ?? setAnonymousUser(),
    });
    router.push('/sell-on-pietra/register');
  };

  return (
    <div className="home-page-intro-card">
      <div className="inner">
        <div className="header">
          <div className="left">
            <div className="icon" style={{ background: card.icon.bgColor }}>
              <Image width={10} height={10} src={card.icon.url} alt={card.agentName} />
            </div>
            <span className="title" style={{ backgroundImage: card.textColor }}>
              {card.agentName}
            </span>
          </div>
          <span className="timestamp">now</span>
        </div>
        <div className="text">
          <div className="left">
            <span className="title">{card.title}</span>
            <span className="description">{card.description}</span>
          </div>
          {card.image && <Image className="image" width={80} height={80} src={card.image} alt={card.title} />}
        </div>
        <div className="learn-more-button" style={{ background: card.textColor }} onClick={handleJoinPietra}>
          <StarsPaywallFilled style={{ color: '#fff' }} /> Learn more
        </div>
      </div>
    </div>
  );
};

export default HomepageV4IntroCard;
